class localStorageService {
  ls = window.localStorage;

  setItem(key, value) {
    value = JSON.stringify(value);
    this.ls.setItem(key, value);
    return true;
  }

  getItem(key, noJson) {
    let value = this.ls.getItem(key);
    if (!value) return null;

    if (noJson)
        return value

    return JSON.parse(value);
  }

  removeItem(key) {
    this.ls.removeItem(key);
  }
}

const service = new localStorageService();
export default service;
